var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconExpandAll = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-expand-all_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 0H5.96c-1.1 0-2 .9-2 2v1.96H2c-1.1 0-2 .9-2 2V16c0 1.1.9 2 2 2h10.04c1.1 0 2-.9 2-2v-1.96H16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm-3.96 14.04v1.31c0 .36-.29.65-.65.65H2.65c-.36 0-.65-.29-.65-.65V6.61c0-.36.29-.65.65-.65h8.74c.36 0 .65.29.65.65v7.43Zm0-10.08H5.96V2.65c0-.36.29-.65.65-.65h8.74c.36 0 .65.29.65.65v8.74c0 .36-.29.65-.65.65h-1.31V5.96c0-1.1-.9-2-2-2Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m3.5 9.5 3.175 2.721a.5.5 0 0 0 .65 0L10.5 9.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-expand-all_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export default SvgIconExpandAll;